import MuiBox from '@mui/material/Box';
import { forwardRef } from 'react';
import { toVendor } from '../styles';
import type { Styleable } from '../styles';

/**
 * An image that takes the library's style vocabulary.
 *
 * Exists because the alternative was `<Box as="img" src=… >`, and the vendor
 * types an image's own attributes onto Box only through polymorphism the wrapper
 * factory flattens. Naming the thing is clearer than reconstructing that.
 */

export interface ImageProps extends Styleable {
  src: string;
  alt: string;
  id?: string;
  loading?: 'eager' | 'lazy';
  onLoad?: () => void;
  onError?: () => void;
}

export const Image = forwardRef<HTMLElement, ImageProps>(function Image(
  { styles, vendorStyles, ...rest },
  ref,
) {
  return <MuiBox ref={ref} component="img" {...rest} sx={toVendor(styles, vendorStyles)} />;
});
